const defaultBehavior = () => ({
  page: 1,
  pageSize: 50,
  query: null,
  basic: null
})

const state = {
  network: {
    tab: 'traffic.alerts',
    page: 1,
    index: 0
  },
  pid: 0,
  dropped: {
    md5: '',
    page: 1,
    pageSize: 50
  },
  behavior: defaultBehavior()
}

const mutations = {
  SET_NETWORK_DETAIL (state, payload) {
    state.network = {
      ...state.network,
      ...payload
    }
  },
  SET_CURRENT_PID (state, payload) {
    state.pid = payload
  },
  SET_DROPPED_DETAIL (state, payload) {
    state.dropped = {
      ...state.dropped,
      ...payload
    }
  },
  SET_BEHAVIOR_DETAIL (state, payload) {
    if (payload?.basic?.pid) {
      state.pid = payload.basic.pid
    }
    state.behavior = {
      ...state.behavior,
      ...payload
    }
  }
}

const actions = {
  resetBehaviorDetail ({ commit }) {
    const resetData = defaultBehavior()
    commit('SET_BEHAVIOR_DETAIL', resetData)
  }
}

const getters = {
  curTab (state) {
    return state.network.tab
  },
  page (state) {
    return state.network.page
  },
  index (state) {
    return state.network.index
  },
  pid (state) {
    return state.pid
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
